<template>
  <div>
    <LoginErrorContext :errorContextProps="errorContext"/>
    <form>
      <ul class="set_login_form">
        <li
            v-for="(field, index_i) in fields"
            :key="index_i"
            :class="field.class"
        >
          <label
              v-for="(item, index_j) in field.items"
              :key="index_j"
              :for="item.id"
              class="member_input"
          >
            <input
                :id="item.id"
                :class="`${item.id} ${item.class}`"
                :type="item.type"
                :autocomplete="item.autocomplete"
                :maxlength="item.maxlength"
                v-model="item.value"
                @input="item.event(item, index_i, index_j)"
                @blur="item.event(item, index_i, index_j)"
            >
            <span class="label">{{ $t(`${item.title}`) }}</span>
            <span :class="item.class === red ? 'description red' : 'hidden'">
              ※ {{ $t(`${item.description}`) }}
          </span>
          </label>
          <LoginBlindIcon
              v-if="field.items[0].id === 'password'"
              :index_i="index_i"
              @togglePasswordShow="togglePasswordShow"
          />
        </li>
      </ul>
    </form>
    <LoginButton @login="login"/>
  </div>
</template>
<script>
import {
  toBlob,
} from "html-to-image";
import axios from "axios";
import {
  mapActions,
} from "vuex";
import {
  _API as _API_URL,
  _HEADER,
} from '@/static';
import validationMethods from '@/common/lib/validation.js';
import _API from "../../../api";
import LoginErrorContext from "./loginErrorContext";
import LoginButton from "./loginButton";
import LoginBlindIcon from "./loginBlindIcon";

export default {
  name: 'LoginBody',
  components: {
    LoginErrorContext,
    LoginButton,
    LoginBlindIcon,
  },
  data() {
    return {
      red: 'red_wrong',
      errorContext: '',
      pass: false,
      fields: [
        {
          index: 0,
          class: '',
          items: [
            {
              id: 'email',
              class: '',
              title: 'user.email',
              type: 'text',
              value: '',
              required: true,
              validation: false,
              description: 'account.email_form_mismatch',
              autocomplete: 'email',
              event: this.checkEachValidation
            }
          ]
        },
        {
          index: 1,
          class: 'relative',
          items: [
            {
              id: 'password',
              class: '',
              title: 'user.password',
              type: 'password',
              value: '',
              required: true,
              validation: false,
              description: 'account.password_required',
              autocomplete: '',
              maxlength: 50,
              event: this.checkEachValidation
            }
          ]
        },
      ]
    };
  },
  watch: {
    fields: {
      deep: true,
      handler(newVal) {
        this.pass = (newVal[0].items[0].validation && newVal[1].items[0].validation);
      }
    }
  },
  methods: {
    ...validationMethods,
    ...mapActions(['changeAuth']),
    tempImageUpload () {
      // fixme: 로그인시 서명 이미지 체크해서 없으면 업로드 (임시)
      _API.USER.getManagerInfoFromServer()
          .then(({data}) => {
            if (data.isSuccess === true) {
              try {
                const managerESignatureImageUrl = data.manager?.managerESignatureImageUrl;

                if (managerESignatureImageUrl === undefined || managerESignatureImageUrl === '') {
                  try {
                    document.getElementById('temp_sign').remove();
                  } catch (e) {

                  }

                  const newDiv = document.createElement('div');
                  newDiv.setAttribute('id', 'temp_sign');
                  newDiv.style.width = '200px';
                  newDiv.style.height = '50px';
                  newDiv.style.lineHeight = '50px';
                  newDiv.style.textAlign = 'center';
                  newDiv.style.borderBottom = '2px solid';
                  newDiv.style.fontFamily = 'Nanum Brush Script, cursive';
                  newDiv.style.fontSize = '25px';
                  newDiv.style.backgroundColor = '#ffffff';

                  newDiv.style.position = 'absolute';
                  newDiv.style.top = 0;
                  const newContent = document.createTextNode(data.manager.managerName.substring(0, 8));
                  const newBy = document.createElement('div');
                  newBy.style.position = 'absolute';
                  newBy.style.paddingTop = '14px';
                  newBy.style.fontSize = '14px';
                  const newByContent = document.createTextNode('By :');
                  newBy.appendChild(newByContent);

                  newDiv.appendChild(newBy);
                  newDiv.appendChild(newContent);
                  document.body.append(newDiv);

                  toBlob(document.getElementById('temp_sign'))
                      .then((file) => {
                        const header = _HEADER();
                        let formData = new FormData();
                        formData.append('file', file);
                        formData.append('folderPath', 'manager/eSignature');

                        axios.post(_API_URL + '/storage/upload/single', formData, {
                          headers: {
                            'x-lang': header["x-lang"],
                            'tz': header["tz"],
                            'x-access-token': header["x-access-token"],
                            'x-refresh-token': header["x-refresh-token"],
                          },
                        }).then(({data}) => {
                          if (data.isSuccess === true) {
                            _API.USER.updateManagerInfoToServer({
                              managerESignatureImageUrl: data.publicPath
                            })
                          }
                        })
                      })
                      .finally(() => {
                        document.getElementById('temp_sign').remove();
                      })
                }
              } catch (e) {

              }
            }
          })
    },
    login() {
      this.errorContext = '';

      if (this.pass) {
        const email = this.fields[0].items[0].value;
        const password = this.fields[1].items[0].value;

        _API.ACCOUNT.login(email, password, undefined)
            .then(res => {
              const data = res.data;
              this.tempImageUpload();
              this.changeAuth({
                seqUser: data.user.seqUser,
                seqManager: data.user.seqManager,
                userEmail: data.user.userEmail,
                userName: data.user.userName,
                accessToken: data.token.accessToken,
                refreshToken: data.token.refreshToken,
                isAuth: true,
              });
              this.$router.push('/');
            })
            .catch(e => {
              switch (e) {
                case '0' :
                  this.errorContext = `${this.$t('account.login_exception')}`;
                  break;
                case '1' :
                  this.errorContext = `${this.$t('account.login_id_email_no')}`;
                  break;
                case '2' :
                  this.errorContext = `${this.$t('account.login_exception')}`;
                  // 유저는 있고 메일 인증도 받았는데, 매니져값이 없다......정말 예기치 못한 에러
                  // 회원탈퇴를 했는데, User테이블의 isActive만 true로 살린 경우
                  break;
                case '4' :
                  this.$modal.show('check-email-auth-modal', email);
                  break;
                case '5' :
                  this.errorContext = `${this.$t('account.login_id_pw_wrong')}`;
                  break;
                default :
                  this.errorContext = `${this.$t('account.login_exception')}`;
                  break;
              }
            });
      } else {
        this.checkIfNotEntered();
      }
    },
    togglePasswordShow(booleans, index_i) {
      if (booleans) {
        this.fields[index_i].items[0].type = 'text';
      } else {
        this.fields[index_i].items[0].type = 'password';
      }
    },
    /**
     *  각 필드를 사용자가 클릭 후 떠나면 (@blur) or (@input)
     *  유효성을 체크한다.
     * @param id
     * @param value
     * @param index_i
     * @param index_j
     */
    checkEachValidation({id, value}, index_i, index_j) {
      let validationCheck = false;
      let errorText = undefined;
      switch (id) {
        case 'email' :
          validationCheck = this.checkEmailValidation(value);
          errorText = value.length !== 0 ? 'account.email_form_mismatch' : 'account.email_required';
          break
        case 'password' :
          validationCheck = (value !== '');
          break
        default :
          break
      }
      this.changeValidation(validationCheck, index_i, index_j, errorText);

    },
    /**
     * fields 에 index_i, index_j 에 해당하는 아이템의 유효성 상태와
     * 클래스를 변경한다. (빨강 경고 문구 표기)
     * @param validationCheck
     * @param index_i
     * @param index_j
     */
    changeValidation(validationCheck, index_i, index_j, errorText) {
      this.fields[index_i].items[index_j].class = validationCheck ? '' : this.red;
      this.fields[index_i].items[index_j].validation = validationCheck;

      if(errorText !== undefined){
        this.fields[index_i].items[index_j].description = errorText;
      }
    },
    /**
     * validation 이 false 인 아이템 빨강 경고 표시
     */
    checkIfNotEntered() {
      this.fields.forEach((field, index_i) => {
        field.items.forEach((item, index_j) => {
          if (!item.validation) {
            this.checkEachValidation(item, index_i, index_j);
          }
        })
      })
    },
  }
}
</script>
<style lang="scss">
.set_login_form {
  li {
    label {
      input {
        box-sizing: border-box;
      }
    }
  }

  .member_input {
    .password {
      padding-right: 65px !important;
      width: 100% !important;
    }

    ::-ms-reveal {
      display: none;
    }
  }
}
</style>